import useMedia from './use-media'

const useTrueAtMediaBreakpointLessThen = (screenWidth: string): boolean => {
  const mediaBreakpoint = `screen and (max-width: ${screenWidth})`
  return useMedia([mediaBreakpoint], [true], false)
}

export default useTrueAtMediaBreakpointLessThen
